import { t } from 'i18next';

import { EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';
export const getChartTitle = (key: string) => {
  const chartTitlesMap = new Map<string, string>([
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST, t('executiveSummary.financialNeeds.researchCost')],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST, t('executiveSummary.financialNeeds.marketingCost')],
    [
      EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST,
      t('executiveSummary.financialNeeds.workingCapitalCost'),
    ],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST, t('executiveSummary.financialNeeds.equipmentCost')],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST, t('executiveSummary.financialNeeds.constructionCost')],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST, t('executiveSummary.financialNeeds.otherCost')],
  ]);

  return chartTitlesMap.get(key) ?? '';
};
